export default __webpack_public_path__ + "media/react/b2b/app/pages/student/student_report/math-f492942228f78439ba1a7c727b182cf7.svg";